<template>
  <div class="banner">
    <div v-show="!noSwiper" class="banner-swiper1" :class="`${templateKey}-banner-swiper1`">
      <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in dataSource" :key="'swiper1' + index">
            <prod-icon :src="item.FileServerPath" :width="265" :height="265"></prod-icon>
          </div>
      </div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <div  v-show="!noSwiper" class="banner-swiper2" :class="`${templateKey}-banner-swiper2`">
      <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in dataSource" :key="'swiper1' + index">
            <prod-icon :src="item.FileServerPath" :width="56" :height="56"></prod-icon>
          </div>
      </div>
    </div>

    <div  class="icon-view">
      <span @click="insertProdFavorite">
        <i class="el-icon el-icon-star-off" v-if="!existProd"></i>
        <i class="el-icon el-icon-star-on" v-else></i>
        {{existProd ? '已收藏': '收藏'}}
      </span>
      <span @click="shareProduct" v-if="showShare"><i class="el-icon el-icon-share"></i>分享</span>
      <span @click="inquiryInfo" style="color:#F56C6C;">
        <i class="el-icon el-icon-phone-outline"></i>
        询价
        </span>
    </div>

    <dir-selector
      ref="dirSelector"
      categoryType="ProdFavoriteDir"
      @ensure="_prodFavorite"
    ></dir-selector>
  </div>
</template>

<script>
import copy from "copy-to-clipboard";
import {Message} from 'element-ui'
import {UserService,CheckLibs} from '@digital-supply-chain/module'
import Event, { EventEnum } from '@/EventEmeitter'
import { OpenService } from '@/service';
//引入组件
import ProdIcon from "@/components/icon/prod-icon.vue";
import DirSelector from '@/components/dir-selector/index.vue'

export default {
  props: {
    dataSource: { default: [] },
    productDetail: { default: {} },
    existProd: { default: false },
    templateKey: { default: '' },
    lectoParams:{default:{ LectotypeParams: [] }},
    noSwiper:{ default: false },
  },
  components: {ProdIcon,DirSelector},
  data() {
    return {
      isInIframe: CheckLibs.isInIframe()
    }
  },
  computed: {
    showShare() {
      if (this.isInIframe) return false;
      return true;
    },
  },
  mounted() {
    var swiper = new window.Swiper(`.${this.templateKey}-banner-swiper2`, {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new window.Swiper(`.${this.templateKey}-banner-swiper1`, {
      autoplay: {
        delay: 2000,//1秒切换一次
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: swiper,
      },
    });
  },
  methods: {
    insertProdFavorite() {
      if (!UserService.token()) {
        Event.emit(EventEnum.LOGIN_OPEN);
        return false;
      }
      if (this.existProd) return;
      this.$refs.dirSelector.show();
    },
    _prodFavorite(currentNode) {
      this.$emit('insertProdFavorite', currentNode);
    },
    shareProduct() {
      if (!CheckLibs.isClient()) {
        this.copy();
        return false;
      }
      const desc = this.productDetail.CompName || this.productDetail.PromoteName;
      const prodName = this.productDetail.ProdName || '';
      const url = `${location.origin}/product/detail/${this.productDetail.ProdID}`;
      const data = encodeURI('<m_link,'+ encodeURIComponent(url) +','+ encodeURIComponent(prodName) +', ' + encodeURIComponent(desc) +',>') ;
      OpenService.openShareBiz(data);
    },
    copy() {
        if (copy(location.href)) {
          Message.success("复制成功，可以转发给好友了");
        } else {
          Message.error("复制失败");
        }
    },
    // 询价
    inquiryInfo() {
      const {CompID, CompLogo,CompName,ProdID,ProdLogo,ProdName}  = this.productDetail;
      const {SkuName} = this.lectoParams;
      const productInfo = {iD:CompID, compName: CompName,ProdLogo,ProdName, skuName:SkuName||''}
      // 使用router.resolve获取完整URL
      const routeData = this.$router.resolve({
        path: '/priceInquiry/edit',
        query: {
          productInfo: JSON.stringify(productInfo),
          type: 'link',
        }
      });
      try{
        // 易分析埋点
        _yfx_trackdata.push(['event','产品询价点击',ProdName,ProdID]);
      }catch(er) {}
      
      // 打开新窗口
      window.open(routeData.href, '_blank');
    },
  }
}
</script>

<style lang="less" scoped>
.icon-view{
  color: @a-color-active;
  padding: 16px 0;
  display: flex;
  justify-content: center;
  span{
    display: inline-flex;
    align-items: center;
    padding: 0 10px;
    cursor: pointer;
  }
  /deep/ .el-icon{
    margin-right: 4px;
  }
}
.banner{
  width: 265px;
  float: left;
  margin-right: 16px;
}
.swiper-button-prev,.swiper-button-next{
  opacity: 0;
  transition: all 0.4s;
}
.banner-swiper1{
  border: 1px solid #D7D6D6;
  overflow: hidden;
  position: relative;
  :deep(.swiper-slide){
    width: 265px;
    height: 265px;
    // padding: 12px;
    margin-top:10px;
  }
  &:hover{
    .swiper-button-prev,.swiper-button-next{
      opacity: 1;
    }
  }
}
.banner-swiper2{
  width: 265px;
  overflow: hidden;
  margin-top: 12px;
  /deep/ .swiper-slide{
    width: 58px;
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D7D6D6;
    opacity: 0.4;
  }
  /deep/ .swiper-slide.swiper-slide-thumb-active{
    opacity: 1;
  }
}
</style>
